import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { inject, observer } from 'mobx-react';
import { Button, ButtonType } from '@checkmarx/cx-ui';
import PortalTextBox from '../../../portal/portalTextBox';
import TextfieldFloatingText from '../../../portal/textfieldFloatingText';
import IconComponent from '../../../portal/iconComponent';
import styles from '../style.scss';
import { QRCodeSVG } from 'qrcode.react';
import { Redirect } from 'react-router-dom';
import ToastrLevelsEnum from '../../../../services/enums/toastrLevelsEnum';
import ToastrService from '../../../../services/ui/toastrService';

@inject('translationsStore', 'twoFAStore','oidcStore','authStore') @observer
export default class SetupAuthApp extends Component {

    componentDidMount() {
        if (this.props.oidcStore.currentUser != null)
            this.props.twoFAStore.setUsername(this.props.oidcStore.currentUser.profile.preferred_username);

        this.props.twoFAStore.getAuthenticatorKeyandQRCode();
    }

    componentWillUnmount() {

        this.props.twoFAStore.changeStepInProgress(false);
        this.props.twoFAStore.authenticatorKetResetted = false;
        this.props.twoFAStore.authenticatorKeyMessage = '';
        this.props.twoFAStore.verificationErrorMessage = '';
    }

    handleVerificationCodeChange = (e) => this.props.twoFAStore.setCode(e.target.value);

    handleSubmitForm = (e) => {
        e.preventDefault();
        const isValid = this.props.twoFAStore.validateTwoFactorSetupForm();

        if (isValid === false) {
            return;
        }
        this.props.twoFAStore.changeStepInProgress(true);
        this.props.twoFAStore.enableTwoFactorAuth().then((response) => {
            this.props.twoFAStore.authenticatorKeyMessage = '';
            if (response === true) {
                if (this.props.isMyProfileMode == true) {
                    this.props.twoFAStore.recoveryCodesMessage = this.props.translationsStore.translate('APPVERIFIED');
                    this.props.twoFAStore.currentStep = this.props.twoFAStore.twoFactorSteps.recoverycodes;
                }
                else {
                    var level = ToastrLevelsEnum.SUCCESS;
                    var message = this.props.translationsStore.translate('TWOFA_SETUP_SUCCESS');
                    ToastrService.triggerToastr({ level, message });
                    this.props.twoFAStore.setRedirectAfterSetup(true);
                }
            }
            else {
                this.props.verificationErrorMessage = this.props.translationsStore.translate('VERIFICATIONERROR');
            }
            this.props.twoFAStore.changeStepInProgress(false);
        });

    }

    render() {
        const { authKey, qrCodeUri, verificationCode, verificationErrorMessage, twoFactorSteps, stepInProgress } = this.props.twoFAStore;

        if (this.props.twoFAStore.redirectAfterSetup === true) {
           return <Redirect to="/" />;
        }

        return (<div>
            <div className={'form-notification-message-wrapper  ' + (this.props.twoFAStore.authenticatorKetResetted ? 'show' : '')}>
                <span className="sucess-message" >
                    <IconComponent iconClassName="alert-success-icon" /> {this.props.twoFAStore.authenticatorKeyMessage}
                </span>
            </div>
            <div className='tab-dialog subTitle' style={{ paddingTop: '5px' }}>{this.props.translationsStore.translate('CONFIGURE_AUTHENTICATOR_APP')}</div>
            <form onSubmit={this.handleSubmitForm}>
                <div>
                    <div style={{ paddingBottom: '15px' }}>{this.props.translationsStore.translate('SETUP_AUTH_MESSAGE1')}</div>
                    <ol>
                        <li>{this.props.translationsStore.translate('SETUP_AUTH_MESSAGE2')} <a target="_blank" href="https://go.microsoft.com/fwlink/?Linkid=825072">{this.props.translationsStore.translate('SETUP_AUTH_MESSAGE3')}</a> {this.props.translationsStore.translate('SETUP_AUTH_MESSAGE4')} <a href="https://go.microsoft.com/fwlink/?Linkid=825073" target="_blank">{this.props.translationsStore.translate('SETUP_AUTH_MESSAGE5')}</a> {this.props.translationsStore.translate('SETUP_AUTH_MESSAGE6')} <a href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=en" target="_blank">{this.props.translationsStore.translate('SETUP_AUTH_MESSAGE3')}</a> {this.props.translationsStore.translate('SETUP_AUTH_MESSAGE4')} <a href="https://itunes.apple.com/us/app/google-authenticator/id388497605?mt=8" target="_blank">{this.props.translationsStore.translate('SETUP_AUTH_MESSAGE5')}</a>. </li>
                        <li>{this.props.translationsStore.translate('SETUP_AUTH_MESSAGE7')} <span className='authKeyText'> {authKey} </span> {this.props.translationsStore.translate('SETUP_AUTH_MESSAGE8')}</li>
                        <li>{this.props.translationsStore.translate('SETUP_AUTH_MESSAGE9')} <br />
                            <div id="codePanel" style={{ padding: '10px' }}>
                                <QRCodeSVG
                                    value={qrCodeUri}
                                    size={128}
                                    bgColor={"#ffffff"}
                                    fgColor={"#000000"}
                                    level={"L"}
                                    includeMargin={false}
                                />
                            </div>
                            <div>
                                <PortalTextBox
                                    floatingLabelText={<TextfieldFloatingText title={this.props.translationsStore.translate('VERIFICATIONCODE')} />}
                                    onChange={this.handleVerificationCodeChange}
                                    errorText={this.props.twoFAStore.verificationErrorMessage}
                                    width='40%'
                                    autoComplete='off'
                                />
                            </div>
                            <div className='buttonDiv' style={{'display': 'flex'}}>
                                <Button
                                    type='submit'
                                    text={this.props.translationsStore.translate('VERIFY')}
                                    value={this.verificationCode}
                                    inProgress={stepInProgress}
                                />
                                <div style={{ 'display' : this.props.isMyProfileMode ? 'block' : 'none' }}>
                                <Button
                                    text={this.props.translationsStore.translate('BACK')}
                                    onClick={() => this.props.twoFAStore.changeStep(twoFactorSteps.authoptions)}
                                    />
                                </div>
                            </div>
                        </li>
                    </ol>
                </div>
            </form>
        </div>)
    }
}
